module.exports = __webpack_public_path__ + "static/media/BC.cc536fce.png";